import React, { Component } from 'react';
import {TextField, Grid} from '@material-ui/core';

class TextAreaField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fieldValue: '',
        }
    }
    
    componentDidMount() {
        // console.log('Called cdm for input...');
        // console.lo/-g(this.props.editRecord);
        if (this.props.editRecord){
           let initVal =  this.props.editRecord[this.props.fieldMap.field];
           if (!initVal){initVal = ''}
           this.setState({fieldValue:initVal});
           this.props.setField({field:this.props.fieldMap.field, value:initVal});
        }
    }

    handleChange = (e) => {
        let fieldValue = e.target.value;
        // console.log('object :>> ', this.props.fieldMap);

        // console.log(this.props.fieldMap)
        if (this.props.fieldMap.f_upperCase){
            fieldValue = fieldValue.toUpperCase();
        }
        this.setState({fieldValue:fieldValue})
        this.props.setField({field:e.target.id, value:fieldValue});
    }  

    render() {
        const spec = this.props.fieldMap;

        return (
            <Grid item>
                <TextField 
                    id={spec.field}
                    type={spec.f_inputType}
                    fullWidth={true}
                    label={spec.headerName}
                    inputProps={{pattern:spec.f_pattern,maxLength:spec.f_maxLength,minLength:spec.f_minLength,max:spec.f_max,min:spec.f_min,step:spec.f_step}}
                    autoCapitalize='off'
                    autoComplete='off'
                    autoCorrect='off'
                    required={spec.f_required}
                    onChange={this.handleChange}
                    value={this.state.fieldValue}
                    disabled={this.props.disabled}
                    variant='standard'
                    multiline
                />
            </Grid>
            
        );
    }
 
}

export default TextAreaField;